export enum BulkCompanyChangePartyNameStepsEnum {
  FormDescription = 0,
  CompanyMemberName = 1,
  Summary = 2,
}
